<template>
    <v-dialog v-model="value" persistent>
        <v-card>
            <v-card-title>
                <span class="text-h5">
                    Gastos na categoria <b>{{ category.name }}</b>
                </span>
            </v-card-title>
            <v-card-text>
                <v-container>
                    <v-row>
                        <v-col>
                            Valor total gasto {{ sumField('value') | toCurrency }}
                        </v-col>
                    </v-row>
                    <v-data-table
                        :headers="headers"
                        :items="records_list"
                        :items-per-page="10"
                        :loading="loading"
                        :sort-by="['date']"
                        :sort-desc="[true]"
                        :mobile-breakpoint="0"
                        item-key="id"
                        show-expand
                        single-expand
                    >
                        <template v-slot:[`item.parcel`]="{ item }">
                            <v-menu offset-y>
                                <template v-slot:activator="{ on, attrs }">
                                    <span
                                        v-if="item.parcel_number"
                                        v-bind="attrs"
                                        v-on="on"
                                    >
                                        {{ item.parcel_number }}/{{ item.number_of_parcels }}
                                    </span>
                                </template>
                                <v-card>
                                    <v-row>
                                        <v-col>
                                            <v-list>
                                                <v-list-item
                                                    v-for="(parcel, index) in item.remaining_parcels"
                                                    :key="index"
                                                >
                                                    <v-list-item-title>Parcela {{ parcel.parcel_number }} em {{ parcel.month }}/{{ parcel.year }} valor {{ parcel.value | toCurrency }}</v-list-item-title>
                                                </v-list-item>
                                            </v-list>
                                        </v-col>
                                    </v-row>
                                    <v-row justify="center">
                                        <v-col cols="auto">
                                            Total restante <b>{{ sumColumnArrayOfObjects(item.remaining_parcels, "value") | toCurrency }}</b>
                                        </v-col>
                                    </v-row>
                                </v-card>
                            </v-menu>
                        </template>
                        <template v-slot:[`item.value`]="{ item }">
                            {{ item.value | toCurrency }}
                        </template>
                        <template v-slot:[`item.date`]="{ item }">
                            <span v-date-usa-br="item.date"></span>
                        </template>
                        <template v-slot:[`item.actions`]="{ item }">
                            <v-row v-if="item.id > 0" class="flex-nowrap">
                                <v-col cols="auto">
                                    <v-btn icon color="primary" @click="editCreditCardRecord(item.id)">
                                        <v-icon>mdi-note-edit</v-icon>
                                    </v-btn>
                                </v-col>
                                <v-col cols="auto">
                                    <v-btn icon color="error" @click="deleteCreditCardRecord(item.id)">
                                        <v-icon>mdi-note-remove</v-icon>
                                    </v-btn>
                                </v-col>
                            </v-row>
                            <v-row v-else-if="item.id_recurrent > 0" class="flex-nowrap">
                                <v-col cols="auto">
                                    <v-btn icon color="primary" @click="editCreditCardRecurrentRecord(item.id_recurrent)">
                                        <v-icon>mdi-repeat</v-icon>
                                    </v-btn>
                                </v-col>
                                <v-col cols="auto">
                                    <v-btn icon color="error" @click="deleteCreditCardRecurrentRecord(item.id_recurrent)">
                                        <v-icon>mdi-repeat-off</v-icon>
                                    </v-btn>
                                </v-col>
                            </v-row>
                            <v-row v-else-if="item.id_extract > 0" class="flex-nowrap">
                                <v-col cols="auto">
                                    <v-btn icon color="primary" @click="editExtract(item.id_extract)">
                                        <v-icon>mdi-note-edit</v-icon>
                                    </v-btn>
                                </v-col>
                                <v-col cols="auto">
                                    <v-btn icon color="error" @click="deleteExtract(item.id_extract)">
                                        <v-icon>mdi-note-remove</v-icon>
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </template>
                        <template v-slot:expanded-item="options">
                            <td :colspan="options.headers.length" class="pa-5">
                                <span class="text-pre" v-html="options.item.long_description" />
                            </td>
                        </template>
                    </v-data-table>
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    color="primary"
                    text
                    :disabled="loading"
                    @click="close"
                >
                    Fechar
                </v-btn>
            </v-card-actions>
        </v-card>
        <dialog-edit-record v-model="dialog_edit" :record-id="credit_card_record_selected" @close="readRecords"></dialog-edit-record>
        <dialog-delete-record v-model="dialog_delete" :record-id="credit_card_record_selected" @close="readRecords"></dialog-delete-record>
        <dialog-edit-recurrent-record v-model="dialog_recurrent_edit" :recurrent-record-id="credit_card_recurrent_record_selected" @close="readRecords"></dialog-edit-recurrent-record>
        <dialog-delete-recurrent-record v-model="dialog_recurrent_delete" :recurrent-record-id="credit_card_recurrent_record_selected" @close="readRecords"></dialog-delete-recurrent-record>
        <dialog-edit-extract v-model="dialog_edit_extract" :extract-id="extract_selected_id" @close="readRecords"></dialog-edit-extract>
        <dialog-delete-extract v-model="dialog_delete_extract" :extract-id="extract_selected_id" @close="readRecords"></dialog-delete-extract>
    </v-dialog>
</template>

<script>
import Vue from "vue";

import DialogEditRecord from "./DialogEditRecord";
import DialogDeleteRecord from "./DialogDeleteRecord";
import DialogEditRecurrentRecord from "../../recurrent-record/components/DialogEditRecurrentRecord";
import DialogDeleteRecurrentRecord from "../../recurrent-record/components/DialogDeleteRecurrentRecord";
import DialogEditExtract from "../../extract/components/DialogEditExtract";
import DialogDeleteExtract from "../../extract/components/DialogDeleteExtract";

import { mapActions, mapState } from "vuex";

export default {
    components: {
        DialogEditRecord,
        DialogDeleteRecord,
        DialogEditRecurrentRecord,
        DialogDeleteRecurrentRecord,
        DialogEditExtract,
        DialogDeleteExtract
    },
    props: {
        value: {
            type: Boolean,
            required: true
        },
        categoryId: {
            type: Number,
            required: false,
            default: null
        },
        customMonth: {
            type: [Number, String],
            required: false,
            default: null
        },
        customYear: {
            type: [Number, String],
            required: false,
            default: null
        }
    },
    data() {
        return {
            loading: false,
            credit_card: {
                name: null,
                limit: null,
                due_date: null,
                closing_date: null
            },
            records_list: [],
            headers: [
                { text: "Título", value: "description" },
                { text: "Parcela", value: "parcel", class: "text-no-wrap", cellClass: "text-no-wrap" },
                { text: "Valor", value: "value", class: "text-no-wrap", cellClass: "text-no-wrap" },
                { text: "Data", value: "date", class: "text-no-wrap", cellClass: "text-no-wrap" },
                { text: "Ações", value: "actions", sortable: false },
                { text: "", value: "data-table-expand" }
            ],
            dialog_edit: false,
            dialog_delete: false,
            dialog_recurrent_edit: false,
            dialog_recurrent_delete: false,
            dialog_edit_extract: false,
            dialog_delete_extract: false,
            credit_card_record_selected: null,
            credit_card_recurrent_record_selected: null,
            extract_selected_id: null,
            category: {
                name: ""
            }
        };
    },
    computed: {
        ...mapState("utils", {
            month: state => state.month,
            year: state => state.year
        })
    },
    watch: {
        value(new_value) {
            if (new_value) {
                this.read();
            }
        }
    },
    methods: {
        ...mapActions("settings", ["ActionDoReadCategory", "ActionDoReadRecordsByCategory"]),
        close() {
            this.records_list = [];
            this.$emit("close");
            this.$emit("input", false);
        },
        async read() {
            this.loading = true;

            if (this.categoryId) {
                await this.ActionDoReadCategory(this.categoryId).then(response => {
                    this.category = response;
                    this.readRecords();
                });
            } else {
                this.close();
            }
        },
        async readRecords() {
            if (this.categoryId) {
                await this.ActionDoReadRecordsByCategory({
                    month: this.customMonth ?? this.month,
                    year: this.customYear ?? this.year,
                    category_id: this.categoryId
                }).then(response => {
                    this.records_list = response.length > 0 ? response : [];
                    this.loading = false;
                });
            } else {
                this.close();
            }
        },
        editCreditCardRecord(id) {
            this.credit_card_record_selected = id;
            this.dialog_edit = true;
        },
        deleteCreditCardRecord(id) {
            this.credit_card_record_selected = id;
            this.dialog_delete = true;
        },
        editCreditCardRecurrentRecord(id) {
            this.credit_card_recurrent_record_selected = id;
            this.dialog_recurrent_edit = true;
        },
        deleteCreditCardRecurrentRecord(id) {
            this.credit_card_recurrent_record_selected = id;
            this.dialog_recurrent_delete = true;
        },
        sumColumnArrayOfObjects(items, value) {
            if (items !== undefined) {
                return Vue.sumColumnArrayOfObjects(items, value);
            } else {
                return "";
            }
        },
        sumField(key) {
            // sum data in give key (property)
            if (this.records_list.length > 0) {
                return this.records_list.reduce((a, b) => a + (b[key] || 0), 0);
            } else {
                return 0;
            }
        },
        editExtract(id) {
            this.extract_selected_id = id;
            this.dialog_edit_extract = true;
        },
        deleteExtract(id) {
            this.extract_selected_id = id;
            this.dialog_delete_extract = true;
        }
    }
};
</script>
